/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { SplitButton } from 'primereact/splitbutton';
import { RadioButton } from 'primereact/radiobutton';

import JustificationModal from '@components/JustificationModal';

import { validatePermissionAction } from '@actions/sessionPermission';

import { SET_VALUES_DOCUMENT } from '@constants/actionType';
import { LANGUAGE_DEFAULT, AuthorizedStatus } from '@constants/general';
import catalogPermissionsId from '@constants/catalogPermissionsId'


import store from '@store';

class ContentLinkForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      url: '',
      target: '_blank',
      errors: [],
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    }

    this.actions = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => {}
      }
    ]
  }

  componentDidMount() {
    const { _content } = this.props;
    if (_content?.link) {
      this.setState({
        ..._content.link
      });
    }
    this.validateOptionsSlit()
    this.setState({ loadingPage: false });
  }

  validateOptionsSlit = () => {
    const { isEdit, validatePermissionAction, estatus } = this.props
    if (isEdit) {
      // @Editar doc
      if (estatus !== AuthorizedStatus.STATUS_AUTHORIZED) {
        const canDeleteVersion = validatePermissionAction(catalogPermissionsId.ELIMINAR_DOCUMENTO)
        if (canDeleteVersion) {
          this.actions.unshift({
            label: this.props.t('Eliminar Version'),
            icon: 'pi pi-times',
            command: () => {
              this.props.deleteVersion()
            }
          })
        }
        const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
        if (hasAuthorized) {
          if (estatus !== AuthorizedStatus.STATUS_REJECTED) {
            this.actions.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
          }
          this.actions.unshift({
            label: this.props.t('Autorizar'),
            icon: 'pi pi-check-circle',
            command: () => {
              this.onSubmit((justification) =>  this.props.authorize(justification))
            }
          })
        } else {
          if (estatus !== AuthorizedStatus.STATUS_PENDING) {
            this.actions.unshift({
              label: this.props.t('Enviar a autorizar'),
              icon: 'pi pi-envelope',
              command: () => {
                this.onSubmit((justification) =>  this.props.sendAuthorize(justification))

              }
            })
          }
        }
      }
    } else {
      // @Nueva doc
      const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
      if (hasAuthorized) {
        this.actions.unshift({
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: () => {
            this.onSubmit((justification) =>  this.props.authorize(justification))
          }
        })
      } else {
        this.actions.unshift({
          label: this.props.t('Enviar a autorizar'),
          icon: 'pi pi-envelope',
          command: () => {
            this.onSubmit((justification) =>  this.props.sendAuthorize(justification))
          }
        })
      }
    }
  }

  onChangeSimple = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { url } = this.state
    let errors = {}
    if (!url) errors = { ...errors, [`url`]: `${t('URL')} ${t('es requerido')}` }
    this.setState({errors})
    return errors
  }

  // onSubmit = async (e) => {
  //   e.preventDefault();
  //   const validate = await this.validateFields()
  //   if (some(validate, {})) return true
  //   const { success } = this.props;
  //   await this.setValuesToStateGlobal();
  //   return success();
  // };

  onSubmit = async (onAction) => {
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { t, success } = this.props;
    await this.setValuesToStateGlobal();
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => onAction(justification),
      },
    });
  };

  setValuesToStateGlobal = async () => {
    const { url, target } = this.state;
    await store.dispatch({
      type: SET_VALUES_DOCUMENT,
      payload: { content: {
        link: {
          url,
          target
        }
      }},
    });
    return true
  };

  render() {
    const { t, btnSubmitLoading, onBack, success } = this.props;
    const { url, target, loadingPage, errors, showModalJustification } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    if (loadingPage) return true;
    return (
      <>
        {/* <form onSubmit={this.onSubmit} autoComplete="false"> */}
        <div>
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-field">
              <label htmlFor="title" className="p-text-bold p-pb-2">
                {t('URL')}
              </label>
              <InputText
                name="url"
                type="text"
                value={url}
                onChange={this.onChangeSimple}
                autoFocus
                className={classNames({
                  'p-invalid': isFormFieldValid(`url`),
                })}
              />
              {getFormErrorMessage(`url`)}
            </div>
            <div className="p-col-6">
              <label className="p-text-bold">{t('Abrir en')}</label>
              <div className="p-field-radiobutton p-mt-2">
                <RadioButton
                  inputId="target1"
                  name="target"
                  value="_blank"
                  onChange={this.onChangeSimple}
                  checked={target === '_blank'}
                />
                <label className="p-pr-3" htmlFor="target1">{t('Nueva ventana')}</label>
                <RadioButton
                  inputId="target2"
                  name="target"
                  value="_self"
                  onChange={this.onChangeSimple}
                  checked={target === '_self'}
                />
                <label htmlFor="target2">{t('Ventana actual')}</label>
              </div>
            </div>
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              {/* <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              /> */}
              <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit((justification) => success(justification))} model={this.actions}/>
            </div>
          </div>
          <JustificationModal
            display={showModalJustification.isVisible}
            title={showModalJustification.title}
            description={showModalJustification.description}
            label={showModalJustification.label}
            onHidden={() => this.setState({showModalJustification: { isVisible: false }})}
            onContinueAction={showModalJustification.continueAction}
          />
        </div>
        {/* </form> */}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _content: state.document.content,
  estatus: state.document.estatus
});

const mapDispatchToProps = {
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ContentLinkForm);
